import type { EmailAiThreadMessage } from '../EmailAiConversation';

export function newEmailAiMessageId(): string {
  return typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `msg-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function plainTextToHtml(text: string): string {
  if (!text.trim()) return '<p><br></p>';
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br/>');
  return `<p>${escaped}</p>`;
}

/** AI Assistant panel: 45% of the app (viewport) width. */
export const EMAIL_AI_PANEL_WIDTH_CLASS = 'w-[45vw] max-w-[45vw] shrink-0';

export function historyToThread(
  messages: Array<{ id: number; role: string; content: string }>,
): EmailAiThreadMessage[] {
  return messages
    .filter((m) => m.role === 'user' || m.role === 'assistant')
    .map((m) => ({
      id: `db-${m.id}`,
      role: m.role as 'user' | 'assistant',
      content: m.content,
    }));
}

export function isValidEmailAiThreadId(emailId: number | null | undefined): emailId is number {
  return typeof emailId === 'number' && Number.isFinite(emailId) && emailId > 0;
}
